<template>
    <div class="stat-chart">
        <h3>{{ title }}</h3>
        <ul>
            <li v-for="(item, index) in limitedParsedData" :key="index">
                <div class="left">
                    <div class="label">{{ item.label }}</div>
                    <div class="bar-wrapper">
                        <div
                            class="bar activity"
                            :style="{ width: item.percentage + '%' }"
                        />
                        <div class="count">{{ item.activityCount }}</div>
                    </div>
                </div>
                <div class="right">
                    <div class="total-label" v-if="index === 0">HCPs</div>
                    <div class="total">{{ item.userCount }}</div>
                </div>
            </li>
        </ul>
        <div v-if="showAllVisible" class="show-all" @click="openModal">
            Show all
        </div>

        <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
            <div class="modal-content">
                <div class="modal-header">
                    <h3>All {{ title }}</h3>
                    <button class="modal-close" @click="closeModal">×</button>
                </div>
                <div class="modal-body">
                    <ul>
                        <li v-for="(item, index) in allParsedData" :key="index">
                            <div class="left">
                                <div class="label">{{ item.label }}</div>
                                <div class="bar-wrapper">
                                    <div
                                        class="bar activity"
                                        :style="{
                                            width: item.percentage + '%'
                                        }"
                                    />
                                    <div class="count">{{
                                        item.activityCount
                                    }}</div>
                                </div>
                            </div>
                            <div class="right">
                                <div class="total-label" v-if="index === 0">
                                    HCPs
                                </div>
                                <div class="total">{{ item.userCount }}</div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        data: {
            type: Object,
            required: false,
            default: () => ({})
        },
        total: {
            type: Number,
            required: false,
            default: 0
        }
    },

    data() {
        return {
            maxItems: 5,
            showModal: false
        };
    },

    computed: {
        limitedParsedData() {
            return this.allParsedData.slice(0, this.maxItems);
        },

        allParsedData() {
            return Object.entries(this.data).map(([label, stats]) => {
                const activityCount = stats.activityCount || 0;
                const userCount = stats.userCount || 0;
                const percentage = this.total
                    ? ((activityCount / this.total) * 100).toFixed(2)
                    : 0;

                return {
                    label,
                    activityCount,
                    userCount,
                    percentage
                };
            });
        },

        showAllVisible() {
            return Object.entries(this.data).length > this.maxItems;
        }
    },

    methods: {
        openModal() {
            this.showModal = true;
            document.body.style.overflow = 'hidden';
        },

        closeModal() {
            this.showModal = false;
            document.body.style.overflow = '';
        }
    }
};
</script>
